export const commentActionTypes = {
    UPDATE_COMMENTS: 'UPDATE_COMMENTS', 
}

export const postActionTypes = {
    TOGGLE_ORIENTATION: 'TOGGLE_ORIENTATION',
}